import React from 'react';
import { useSelector } from 'react-redux';
import PropTypes from 'prop-types';

import {
  CAMPAIGN_TYPES,
  CAMPAIGNTYPE_ENTITLEMENTOWNER,
} from '../../../utils/constant';
import CertsUserListDropdown from '../../CertsUserListDropdown';

import './BulkActionReassign.css';

function BulkActionReassignList({
  isSkipCertifier,
  isSubmitting,
  isCritical,
  bulkActionReassign,
  setBulkActionReassign,
  certKey,
  showDefaultCertifier,
  defaultReassignee,
  defaultAssigneName,
  placeholder,
  certifierUserKey,
}) {
  const {
    core: { campaignType },
  } = useSelector((state) => state?.certifications?.details);
  const isEOCampaign =
    CAMPAIGN_TYPES[campaignType] === CAMPAIGNTYPE_ENTITLEMENTOWNER;

  const handleAssigneeChange = (selectedOption) => {
    let reassignToName = '';

    if (selectedOption?.username?.trim()?.length !== 0) {
      reassignToName = selectedOption?.username;
    } else {
      reassignToName = `${selectedOption?.firstname} ${selectedOption?.lastname}`;
    }

    setBulkActionReassign((prev) => ({
      ...prev,
      reassignTo: selectedOption?.value || '',
      reassignToName,
    }));
  };

  return (
    <CertsUserListDropdown
      defaultReassignee={defaultReassignee}
      defaultAssigneName={defaultAssigneName}
      onSelect={handleAssigneeChange}
      isCritical={isCritical}
      isDisabled={
        isSkipCertifier || bulkActionReassign?.isSkipCertifier || isSubmitting
      }
      selectedUser={bulkActionReassign?.reassignTo?.trim()?.length !== 0}
      certifierUserKey={certifierUserKey}
      certKey={certKey}
      showDefaultCertifier={isEOCampaign || showDefaultCertifier}
      placeholder={placeholder}
    />
  );
}

BulkActionReassignList.propTypes = {
  isSkipCertifier: PropTypes.bool.isRequired,
  isSubmitting: PropTypes.bool.isRequired,
  isCritical: PropTypes.bool.isRequired,
  bulkActionReassign: PropTypes.shape({
    reassignTo: PropTypes.string,
    isSkipCertifier: PropTypes.bool,
  }).isRequired,
  setBulkActionReassign: PropTypes.func.isRequired,
  certKey: PropTypes.string.isRequired,
  showDefaultCertifier: PropTypes.bool.isRequired,
  defaultReassignee: PropTypes.string.isRequired,
  defaultAssigneName: PropTypes.string.isRequired,
  placeholder: PropTypes.string.isRequired,
  certifierUserKey: PropTypes.string.isRequired,
};

export default React.memo(BulkActionReassignList);
